import { createContext } from 'react';

export const defaultFeatureFlagContextValues = {
  isDarkModeEnabled: false,
  isCompanyAuthEnabled: false,
  isSelectVenueActive: false,
  isMultiInviteActive: false,
  isWebView: false,
  isXceedAccess: false,
  isPublicEventReportActive: false,
  isPublicEventReportPage: false,
  isUserManagementActive: false,
  testCompanyIds: '',
  externalPlatformEnabledIds: '',
  isExternalPlatformSectionEnabled: false,
  isUserResetPasswordEnabled: false,
  isCompanyInfoEnabled: false,
  isCompanyIntegrationsEnabled: false,
  isAddVenueEnabled: false,
  isHideEndingTimeEnabled: false,
  isTicketsLeftThresholdEnabled: false,
  isPerTicketAddonBookingEnabled: false,
  isOfflineSalesPassScopeEnabled: false,
};

export const FeatureFlagContext = createContext(defaultFeatureFlagContextValues);
